import React from 'react';
// Components
import Divider from 'ui/Divider/Divider';

import styles from './Banner.module.scss';

export const Banner: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>ABOUT US</h1>
        <Divider className={styles.divider} />
        <p className={styles.description}>
          We’re sports fans, technologists and entrepreneurs. We started by
          helping our friends who are professional athletes build a merch line
          that could easily be sold online without technical knowhow. We
          didn&apos;t want to stop there. We added the latest video technology
          to the platform allowing athletes to stream live events to allow their
          audience to watch with them, and also offer video Personal Videos.
          We’re just getting started in joining the latest in technology to the
          world of sports entertainment and engagement.
        </p>
        <p className={styles.cta}>
          <span>MILLIONS</span> will be the largest athlete centric merchandise
          and video engagement platform in the world.
          <span> To start … We dream big!</span>
        </p>
      </div>
    </div>
  );
};
